import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api, fmtMoney } from "@/lib/api";
import { Link } from "react-router-dom";

export default function AccountPage() {
  const { user, logout } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get("/orders/mine").then((r) => setOrders(r.data.items));
  }, []);

  return (
    <div className="max-w-[1000px] mx-auto px-6 md:px-12 py-12" data-testid="account-page">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <div className="ipv-eyebrow text-[#0A1C40]">Account</div>
          <h1 className="font-display font-black text-4xl tracking-tighter mt-2">Hi, {user?.name}</h1>
          <p className="text-gray-600 mt-1 text-sm">{user?.email}</p>
        </div>
        <button onClick={logout} className="btn-outline" data-testid="logout-btn">Sign out</button>
      </div>

      <div className="mt-10">
        <div className="ipv-eyebrow mb-4">Your orders</div>
        {orders.length === 0 ? (
          <div className="border border-dashed border-gray-300 p-12 text-center">
            <p className="text-gray-600">No orders yet.</p>
            <Link to="/shop" className="btn-primary inline-flex mt-5">Start shopping</Link>
          </div>
        ) : (
          <div className="border border-gray-200 divide-y divide-gray-200">
            {orders.map((o) => (
              <Link
                to={`/order/${o.order_number}?email=${encodeURIComponent(o.customer_email)}`}
                key={o.id}
                className="p-5 grid grid-cols-4 gap-4 text-sm hover:bg-gray-50"
                data-testid={`account-order-${o.order_number}`}
              >
                <div>
                  <div className="font-bold">{o.order_number}</div>
                  <div className="text-gray-500 text-xs">{new Date(o.created_at).toLocaleDateString()}</div>
                </div>
                <div>
                  <div className="ipv-eyebrow text-[10px]">Status</div>
                  <div className="font-bold uppercase">{o.status}</div>
                </div>
                <div>
                  <div className="ipv-eyebrow text-[10px]">Fulfillment</div>
                  <div className="font-bold capitalize">{o.fulfillment}</div>
                </div>
                <div className="text-right">
                  <div className="ipv-eyebrow text-[10px]">Total</div>
                  <div className="font-display font-bold">{fmtMoney(o.total)}</div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
